'use strict';

import $ from 'jquery';
import setNextUrl from '../../utils/setNextUrl';

const DEFAULT_NEXT_URL = `${window.location.origin}/register`;

export default function showLoginForm() {
  const $inputMail = $('#email');
  const $btnNext = $('#next');
  const $ssoConfirmBox = $('#sso-box');
  const $ssoUser = $('#sso-user');
  const $noSsoUser = $('#no-sso-user');

  function handleSSOBox(nextURL) {
    if (nextURL && nextURL !== DEFAULT_NEXT_URL) {
      $ssoUser.show();
      $ssoConfirmBox.show();
      $noSsoUser.hide();
    } else {
      $ssoUser.hide();
      $ssoConfirmBox.hide();
      $noSsoUser.show();
    }
  }

  function updateNextUrl() {
    const email = $inputMail.val().trim();
    const nextUrl = setNextUrl(email, DEFAULT_NEXT_URL);
    handleSSOBox(nextUrl);
    $btnNext.attr('href', nextUrl);
  }

  $inputMail.on('keyup', updateNextUrl);
}
